import { render, staticRenderFns } from "./ParticaTitleBase.vue?vue&type=template&id=4d1358df&"
import script from "./ParticaTitleBase.vue?vue&type=script&lang=ts&"
export * from "./ParticaTitleBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports